import { render, staticRenderFns } from "./crowd-congregate.vue?vue&type=template&id=3e63c15e&scoped=true&"
import script from "./crowd-congregate.vue?vue&type=script&lang=ts&"
export * from "./crowd-congregate.vue?vue&type=script&lang=ts&"
import style0 from "./crowd-congregate.vue?vue&type=style&index=0&id=3e63c15e&prod&lang=scss&scoped=true&"
import style1 from "./crowd-congregate.vue?vue&type=style&index=1&id=3e63c15e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e63c15e",
  null
  
)

export default component.exports